export function leftDrawerOpen (state, leftDrawerOpen) {
  state.leftDrawerOpen = leftDrawerOpen
}

export function user(state, user){
  state.user = user
}

export function videos(state, videos){
  state.videos = videos
}

export function messages(state, messages){
  state.messages = messages
}

export function settings(state, settings){
  state.settings = settings
}

export function toggleFavoriteMessage(state, id){
  let index = state.messages.findIndex(m => m.id === id)

  if(index < 0) {
    return
  }

  state.messages[index].favorite = !state.messages[index].favorite
}

export function signUpInfo(state, signUpInfo){
  state.signUpInfo = signUpInfo
}

export function notifications(state, notifications){
  state.notifications = notifications
}

export function dob_required(state, dob_required){
  state.dob_required = dob_required
}
